module.exports = __webpack_public_path__ + "static/step_3-76813c55ae5a0c21f0ab94fbb7037a0f.png";